"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargePointTariff = void 0;
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
/**
 * Validates on the following properties:
 * - Is number
 * - Min of 0.001
 * - Max of 1
 */
const ChargePointTariff = () => (0, base_models_1.combineDecorators)((0, class_validator_1.IsNumber)(), (0, class_validator_1.Min)(0.001), (0, class_validator_1.Max)(1));
exports.ChargePointTariff = ChargePointTariff;
